// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {
  versionData: {},
};

export const versionsSlice = createSlice({
  name: 'versions',
  initialState,
  reducers: {
    setVersionData: (state, { payload }) => ({
      ...state,
      versionData: payload,
    }),
  },
});

export const { setVersionData } = versionsSlice.actions;

export default versionsSlice.reducer;
